import React, {useCallback} from 'react';
import {
    Button,
    Icon,
    PriorityIcon,
    TriggerWrapperV2
} from '@priority-software/priority-style-react';
import {automationMenuRef} from '../../constants';
import {texts} from '../../../../texts';
import styles from './styles.module.scss';
import {ModernTooltip} from '../../../../../../components/Common/Tooltip/ModernTooltip';

export const ButtonTrigger = ({isOpen, onClick, disabled, buttonComponentClasses = ''}) => {
    const [isShowTooltip, setIsShowTooltip] = React.useState(false);

    const handleToggleShow = useCallback(
        (flag: boolean) => {
            if (isOpen) {
                setIsShowTooltip(false);
            } else {
                setIsShowTooltip(flag);
            }
        },
        [isOpen]
    );

    return (
        <TriggerWrapperV2 isOpen={isOpen} className={styles.triggerWrapper}>
            <ModernTooltip
                tooltip={texts.menu_trigger}
                maxWidth={160}
                position="bottom"
                show={isShowTooltip}
                toggleShow={handleToggleShow}
            >
                <Button
                    componentClasses={buttonComponentClasses}
                    inputRef={automationMenuRef}
                    skin="text"
                    onClick={onClick}
                    prefixIcon={PriorityIcon.automations}
                    suffixIcon={<Icon icon={PriorityIcon.arrowDropDown} />}
                    disabled={disabled}
                >
                    <span>{texts.menu_trigger}</span>
                </Button>
            </ModernTooltip>
        </TriggerWrapperV2>
    );
};
